import getCustomPalettesToCreate from './get-custom-palettes-to-create';
import getCustomPalettesToDelete from './get-custom-palettes-to-delete';
import getCustomPalettesToUpdate from './get-custom-palettes-to-update';
import getCustomGlobalStylesRootRule from './get-custom-global-styles-root-rule';
import getCustomGlobalStylesVariables from './get-custom-global-styles-variables';
import setCustomGlobalStylesVariables from './set-custom-global-styles-variables';
import getCustomFontPairsToCreate from './get-custom-font-pairs-to-create';
import getCustomFontPairsToDelete from './get-custom-font-pairs-to-delete';
import getCustomFontPairsToUpdate from './get-custom-font-pairs-to-update';

export default {
  getCustomPalettesToCreate,
  getCustomPalettesToDelete,
  getCustomPalettesToUpdate,
  getCustomFontPairsToCreate,
  getCustomFontPairsToDelete,
  getCustomFontPairsToUpdate,
  getCustomGlobalStylesRootRule,
  getCustomGlobalStylesVariables,
  setCustomGlobalStylesVariables,
};
